import { createContext, useState } from 'react';

export const EmailTypeContext = createContext(null);

export const EmailTypeProvider = ({ children }) => {
  const [emailTypeQuestions, setEmailTypeQuestions] = useState({}) 
  const [numberTypeQuestions, setNumberTypeQuestions] = useState({}) 
  const [floatingTypeQuestions, setFloatingTypeQuestions] = useState({}) 

  return (
    <EmailTypeContext.Provider value={{
      emailTypeQuestions, setEmailTypeQuestions,
      numberTypeQuestions, setNumberTypeQuestions,
      floatingTypeQuestions, setFloatingTypeQuestions
    }}>
      {children}
    </EmailTypeContext.Provider>
  )
}